import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { ExpenseCategory, rodeoExpenseItems } from '../../../../../model/rodeoExpenseItems';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ExpenseItemService } from '../../../../../services/ExpensesItems.service';
import { AlertMessager } from '../../../../../lib/alertMessager';
import { Rodeo } from '../../../../../model/rodeo';

@Component({
  selector: 'new-expense-item',
  templateUrl: 'new-expense-item.html'
})
export class NewExpenseItemComponent implements OnInit {
  private rodeo: Rodeo;
  expenseItem: rodeoExpenseItems;
  rodeoExpenseForm: FormGroup;
  expenseCategories = Object.values(ExpenseCategory);
  selectedCategory: string;
  text: string;
  isNew: boolean = true;
  submitAttempt: boolean = false;

  validationMessages = {
    amount: {
      required: 'Amount is required.',
      pattern: 'Please enter a valid number.'
    },
    description: {
      required: 'Description is required.'
    },
    expenseCategory: {
      required: 'Expense category is required.'
    }
  };

  ngOnInit() {
    const numberPattern = /^[0-9]+(\.[0-9]{1,2})?$/;
    this.rodeoExpenseForm = this.formBuilder.group({
      description: [this.expenseItem.description, Validators.required],
      expenseCategory: [this.expenseItem.expenseCategory, Validators.required],
      amount: [this.expenseItem.amount, [Validators.required, Validators.pattern(numberPattern)]]
    });

    if (this.expenseItem.id) {
      this.selectedCategory = this.expenseItem.expenseCategory;
      this.isNew = !this.expenseItem;
    }
  }

  constructor(
    public loadingCtrl: LoadingController,
    private alertMessager: AlertMessager,
    private formBuilder: FormBuilder,
    private navParams: NavParams,
    private nav: NavController,
    private modalCtrl: ModalController,
    private viewController: ViewController,
    private expenseItemService: ExpenseItemService
  ) {
    this.expenseItem = this.navParams.get('expenseItem');
    this.rodeo = this.navParams.get('rodeo');
  }

  showLoading(text: string) {
    let loader = this.loadingCtrl.create({
      content: text
    });
    loader.present();
    return loader;
  }

  dismissLoading(loader: any) {
    if (loader) {
      loader.dismiss();
    }
  }

  async save() {
    this.submitAttempt = true;

    if (!this.rodeoExpenseForm.valid) {
      return;
    }

    const isUpdating = this.expenseItem && this.expenseItem.id !== undefined;
    const actionMessage = isUpdating ? 'Updating ExpenseItem' : 'Creating Expense Item';

    const newExpenseItem = isUpdating ? this.expenseItem : new rodeoExpenseItems();

    newExpenseItem.description = this.rodeoExpenseForm.value.description;
    newExpenseItem.expenseCategory = this.rodeoExpenseForm.value.expenseCategory;
    newExpenseItem.amount = this.rodeoExpenseForm.value.amount;

    if (!isUpdating) {
      newExpenseItem.rodeoId = this.rodeo.id;
    }

    let loader = this.showLoading(actionMessage);

    try {
      if (isUpdating) {
        await this.expenseItemService.updateExpenseItem(newExpenseItem);
      } else {
        const response = await this.expenseItemService.createExpenseItem(newExpenseItem);
        newExpenseItem.id = response.id;
      }

      this.viewController.dismiss(newExpenseItem);
    } catch (error) {
      this.alertMessager.showError('Error', error.message);
    } finally {
      this.dismissLoading(loader);
    }
  }

  cancel() {
    this.nav.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/expense-items/new-expense-item.component.ts